import { render, staticRenderFns } from "./MediaImg.vue?vue&type=template&id=1cd95bd7&"
import script from "./MediaImg.vue?vue&type=script&lang=js&"
export * from "./MediaImg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports